// removed by extract-text-webpack-plugin
module.exports = {"wraper-magazine-export":"magazines_Mw2Rd","wraper-magazine-export__button":"magazines_31tX2","wraper-magazine-export__button-pdfs":"magazines_3_pmG","wraper-magazine-export__exporteds":"magazines_2FV82","wraper-magazine-export__all-exporteds":"magazines_2QHPj","warning-message":"magazines_1Y2CD","exported-magazines":"magazines_3Nv9o","list-exported":"magazines_Gs9DU","informations-pdfs-exported":"magazines_2BsnO","exported-pdf":"magazines_3jXCc","ba-modal-card":"magazines_1Dk6e","ba-modal-card__title":"magazines_36Cqc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Heade/components/ExportMagazine/styles.scss
// module id = 1007
// module chunks = 1